import axios from '../config/axios';
import { notification } from 'antd';
import {getResponseHandler,header} from './commonService'

const NotificationMSG = {
     
    getAllNotification : async (data={}) => {
        try{
            let rowData;
            rowData = await axios.get('/notifications/',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    getNotificationList : async (data={}) => {
        try{
            let rowData;
            rowData = await axios.get('/notifications/',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    }, 
    saveNotification : async (data={}) =>{
        try{
            const rowData = await axios.post('/notifications',header(data,1))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },
    changeStatus : async (data = {}) => {
        try{
            const rowData = await axios.post('/notifications/statusChange',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },
    unreadNotification : async (data = {}) => {
        try{
            const rowData = await axios.post('/notifications/unreadNotification',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },
   

}


export default NotificationMSG
